import React from 'react'
import { Badge } from '../../atoms/badge'
import { If } from '../../atoms/if'
import { Loader } from '../../atoms/loader'
import { Text } from '../../atoms/text'
import { StyledTabLabel, EmptyContent, LoaderBox } from './styles'
import EmptyImage from '../../../images/icon_no_notifications.svg'
import { NotificationItem } from '../notificationItem'
import { useTranslation } from '../../../context/translationProvider'

export const PlayerInboxContent = ({
  expiredNotifications,
  isExpired,
  onClose,
  unreadNotifications,
  readNotifications,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <LoaderBox>
        <Loader />
      </LoaderBox>
    )
  }

  const { translate } = useTranslation()

  if (isExpired) {
    return (
      <If
        condition={expiredNotifications?.length > 0 || isLoading}
        render={() => (
          <>
            {expiredNotifications.map((item) => (
              <NotificationItem
                key={item.playerNotificationId}
                image={item.type.icon}
                title={item?.langTitle}
                category={item?.type}
                isExpired={true}
                expireTime={item?.endDate}
                isUnread={false}
                onClose={onClose}
                playerNotificationId={item?.playerNotificationId}
                startDate={item?.startDate}
              />
            ))}
          </>
        )}
        renderElse={() => (
          <EmptyContent>
            <div>
              <img src={EmptyImage} />
              <Text textAlign="center">
                {translate('playerInbox.noExpiredMessages')}
              </Text>
            </div>
          </EmptyContent>
        )}
      />
    )
  }

  return (
    <If
      condition={
        unreadNotifications?.length > 0 ||
        readNotifications?.length > 0 ||
        isLoading
      }
      render={() => (
        <>
          <If
            condition={unreadNotifications?.length > 0}
            render={() => (
              <>
                <StyledTabLabel>
                  {translate('playerInbox.unread')}
                  <Badge theme="blue">{unreadNotifications?.length}</Badge>
                </StyledTabLabel>
                {unreadNotifications.map((item) => (
                  <NotificationItem
                    key={item.playerNotificationId}
                    image={item.type.icon}
                    title={item?.langTitle}
                    description={
                      item?.style?.description !== 'TITLE_ONLY' &&
                      item?.langContent
                    }
                    category={item?.type}
                    isExpired={false}
                    expireTime={item?.endDate}
                    isUnread={true}
                    onClose={onClose}
                    playerNotificationId={item?.playerNotificationId}
                    startDate={item?.startDate}
                  />
                ))}
              </>
            )}
          />
          <If
            condition={readNotifications?.length > 0}
            render={() => (
              <>
                <StyledTabLabel>{translate('playerInbox.read')}</StyledTabLabel>
                {readNotifications.map((item) => (
                  <NotificationItem
                    key={item.playerNotificationId}
                    image={item.type.icon}
                    title={item?.langTitle}
                    description={
                      item?.style?.description !== 'TITLE_ONLY' &&
                      item?.langContent
                    }
                    category={item?.type}
                    isExpired={false}
                    expireTime={item?.endDate}
                    isUnread={false}
                    onClose={onClose}
                    playerNotificationId={item?.playerNotificationId}
                    startDate={item?.startDate}
                  />
                ))}
              </>
            )}
          />
        </>
      )}
      renderElse={() => (
        <EmptyContent>
          <div>
            <img src={EmptyImage} />
            <Text textAlign="center">
              {translate('playerInbox.noActiveMessages')}
            </Text>
            <Text textAlign="center">{translate('playerInbox.stayTuned')}</Text>
          </div>
        </EmptyContent>
      )}
    />
  )
}
